import { Button } from '@headlessui/react'
import { BrushCleaning, Bug, Settings } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import Avatar from '@/components/common/Avatar'
import { useEffectOnce } from '@/hooks/useEffectOnce'
import { useSearchStore } from '@/pages/search/stores/search'
import { useAuthStore } from '@/stores/authStore'
import { usePrintActions } from '@/stores/usePrintStore'
import { useUIStore } from '@/stores/useUIStore'

const Header: React.FC = () => {
  const navigate = useNavigate()
  const { user, clearAuth } = useAuthStore()
  const { showSuccess } = useUIStore()

  const routeToDashboard = () => {
    navigate('/')
  }

  const routeToSettingPage = () => {
    navigate('/settings')
  }

  const handleLogout = () => {
    clearAuth()
    navigate('/login')
  }

  const removeAllCache = () => {
    useSearchStore.persist.clearStorage()
    showSuccess("缓存清理成功")
  }

  const routeToDebugPage = () => {
    navigate('/demo')
  }
  
  const { initial } =usePrintActions()
  useEffectOnce(() => {
    initial()
  })

  return (
    <div className="bg-white dark:bg-slate-600  shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
              <Button className="flex" onClick={() => routeToDashboard()}>
                <span className="sm:hidden">保</span>
                <span className="hidden sm:inline">保税仓储管理系统</span>
              </Button>
            </h1>
          </div>
          <div className="flex items-center space-x-4">
            <div className="bg-gray-100 p-2 rounded-lg">
              <Button
                className="flex items-center justify-center"
                onClick={() => routeToDebugPage()}
              >
                <Bug />
              </Button>
            </div>
            <div className="bg-gray-100 p-2 rounded-lg">
              <Button
                className="flex items-center justify-center"
                onClick={() => removeAllCache()}
              >
                <BrushCleaning />
              </Button>
            </div>
            <div className="bg-gray-100 p-2 rounded-lg">
              <Button
                className="flex items-center justify-center"
                onClick={() => routeToSettingPage()}
              >
                <Settings />
              </Button>
            </div>
            <div className="flex items-center space-x-2">
              <Avatar
                src={user?.avatarUrl}
                name={user?.nick}
                size="lg"
                alt="用户头像"
              />
              <span className="hidden sm:inline text-sm font-medium text-gray-700 dark:text-white">
                {user?.nick}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-500 hover:text-gray-700 dark:text-white hover:dark:text-white"
            >
              退出
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
